import React from "react";
import Head from "next/head";
import { RouteName } from "../utils/route.utils";
import { structuredAwardData } from "../utils/constants/Awards";
import TAGS from "../public/headJson.json";
import Footer from "../components/common/Footer";
import AwardsAndRecognition from "../components/AwardsAndRecognition";

const AwardsAndRecognitionPage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.awardsAndRecognition.title}</title>
        <meta name="title" content={TAGS.awardsAndRecognition.title} />
        <meta
          name="description"
          content={TAGS.awardsAndRecognition.description}
        />
        <link rel="canonical" href={RouteName.awardsAndRecognitions} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.awardsAndRecognitions} />
        <meta property="og:title" content={TAGS.awardsAndRecognition.title} />
        <meta
          property="og:description"
          content={TAGS.awardsAndRecognition.description}
        />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta
          property="twitter:url"
          content={RouteName.awardsAndRecognitions}
        />
        <meta
          property="twitter:title"
          content={TAGS.awardsAndRecognition.title}
        />
        <meta
          property="twitter:description"
          content={TAGS.awardsAndRecognition.description}
        />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredAwardData),
          }}
        />
      </Head>

      <div>
        <AwardsAndRecognition />
        <Footer />
      </div>
    </>
  );
};

export default AwardsAndRecognitionPage;
